import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';

import { Observable, map, startWith } from 'rxjs';

import { UserAccountData } from '@hdms/shared/page-frame/types';

import { ContactBodyLoaderService } from './contact-body-loader.service';

@Component({
  selector: 'shrd-pf-ft-contact-body',
  templateUrl: './contact-body.component.html',
  styleUrls: ['./contact-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactBodyComponent implements OnInit {
  isLoading$: Observable<boolean>;

  @Input() userData: UserAccountData;

  @ViewChild('contactBodyContainer', { read: ViewContainerRef, static: true })
  private readonly bodyContainerRef: ViewContainerRef;
  private readonly loader = inject(ContactBodyLoaderService);

  constructor() {
    this.isLoading$ = this.loader.loaded$.pipe(
      startWith(null),
      map(data => !data)
    );
  }

  ngOnInit(): void {
    this.loader.loadBodyComponent(this.bodyContainerRef, this.userData);
  }
}
